export const ONE_KILOBYTE = 1024;
export const ONE_MEGABYTE = 1024 * 1024;
const THIRTY_MEGABYTES = 30 * ONE_MEGABYTE;
export const DEFAULT_MAX_FILE_SIZE = THIRTY_MEGABYTES;
const SIZE_UNITS = ["Bytes", "KB", "MB", "GB", "TB"];

export function getReadbleFileSize(bytes: number) {
  if (bytes === 0) return "0 Bytes";

  const index = Math.floor(Math.log(bytes) / Math.log(1024));
  if (index > SIZE_UNITS.length - 1) {
    return "File too large";
  }

  return `${Math.round(bytes / Math.pow(1024, index))} ${SIZE_UNITS[index]}`;
}

export function getDefaultMaxFileSizeErrorMessage(maxSize: number) {
  return `File is too large: max allowed size is ${getReadbleFileSize(
    maxSize,
  )}`;
}

const listFormatter = new Intl.ListFormat("en", {
  style: "long",
  type: "conjunction",
});

export function getDefaultAcceptedFileTypesErrorMessage(
  acceptedFileTypes: Record<string, string[]>,
) {
  const uniqueFileTypes = Array.from(
    new Set(Object.values(acceptedFileTypes).flat()),
  );

  return `File type is not supported: allowed type${uniqueFileTypes.length > 1 ? "s are" : " is"}
         ${listFormatter.format(uniqueFileTypes)}`;
}

export function download({ blob, filename }: { blob: Blob; filename: string }) {
  // Create a temporary URL for the Blob
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;

  link.click();

  // Clean up
  URL.revokeObjectURL(url);
}

export async function downloadFromUrl({
  url,
  filename,
}: {
  url: string;
  filename?: string;
}) {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    download({ blob, filename: filename || "download" });
    return true;
  } catch (error) {
    console.error("Failed to download file:", error);
    return false;
  }
}
